import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "CSS Grid"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "css-grid"
    }}>{`CSS Grid`}</h1>
    <p>{`CSS Grid Layout is a powerful way to handle complex two-dimensional layouts.
Using Theme UI's `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop gives you quick access to your space scale as well as a quick way to change styles responsively.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<div
  sx={{
    display: 'grid',
    gridGap: 4,
    gridTemplateColumns: ['auto', '1fr 256px'],
  }}>
  <main>Main</main>
  <aside>Sidebar</aside>
</div>
`}</code></pre>
    <p>{`Use a wrapping `}<inlineCode parentName="p">{`<div>`}</inlineCode>{` element with the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop to control the layout of direct child elements.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */

export default (props) => (
  <div
    sx={{
      display: 'grid',
      gridGap: 4, // theme.space[4]
      // use arrays for mobile-first responsive styles
      gridTemplateColumns: [
        'auto', // default to a stacked layout on small screens
        '1fr 256px', // use columns for larger screens
      ],
    }}>
    <main>{props.children}</main>
    <div>Sidebar</div>
  </div>
)
`}</code></pre>
    <p>{`See also: `}<a parentName="p" {...{
        "href": "/components/grid"
      }}>{`Grid component`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      